// extracted by mini-css-extract-plugin
module.exports = {"viewport":"Xufw9ySlAGJTuhPETTgIwg=="};